import * as React from 'react';
import * as styles from './UseAnotherVertical.css';
import { getDesktopUrl } from './utils';

interface IUseAnotherVerticalProps {
  deviceService: { deviceOperatingSystem: string };
}

export const UseAnotherVertical = (props: IUseAnotherVerticalProps) => {
  const { deviceService: { deviceOperatingSystem } } = props;

  const url = getDesktopUrl(deviceOperatingSystem);

  const downloadApp = (e: React.MouseEvent) => {
    e.preventDefault();

    if (url) {
      window.location.assign(url);
    }
  };

  const continueDesktop = (e: React.MouseEvent) => {
    e.preventDefault();

    const thirtyMinutes = new Date();
    thirtyMinutes.setMinutes( thirtyMinutes.getMinutes() + 30 );

    document.cookie = `fpAdaptiveMode=desktop;path=/;domain=.cian.ru;expires=${thirtyMinutes.toUTCString()};`;
    window.location.reload();
  };

  return (
    <div className={styles['wrapper']}>
      <span className={styles['title']}>Удобнее в мобильном приложении</span>
      <p className={styles['description']}>
        Мы дорабатываем эту часть мобильного сайта.
        Чтобы быстро и удобно разместить свой объект,
        пожалуйста скачайте приложение ЦИАН или
        продолжайте заполнение в версии для компьютера
      </p>
      <button className={styles['download-button']} onClick={downloadApp}>
        Скачать приложение
      </button>
      <button className={styles['continue-desktop-button']} onClick={continueDesktop}>
        Продолжить заполнять
      </button>
    </div>
  );
};
